import { types } from 'mobx-state-tree';

import Actions from './Actions';

const ModelProps = {
  value: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  feedback: types.optional(types.maybeNull(types.boolean), null),
  isRevealed: types.optional(types.boolean, false),
  isEdited: types.optional(types.boolean, false),
  isManuallyAdded: types.optional(types.boolean, false),
  doNotCall: types.maybeNull(types.string),
  isDncPhone: types.optional(types.maybeNull(types.boolean), false),
  emailConfidence: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  status: types.optional(types.maybeNull(types.string), null),
  shownDate: types.optional(types.maybeNull(types.string), null),
  shown_by: types.maybe(types.model({ user_id: types.maybe(types.number) })),
};

const ContactData = types
  .model(ModelProps)
  .actions(Actions);

export default ContactData;
